import { MemberDetailLayout } from "@/components/members/detail/member-detail-layout.tsx";
import { m } from "@/paraglide/messages.js";
import { memberDetailQueryOptions } from "@/services/members-service.ts";
import { createEntityErrorBoundary } from "@/utils/entity-error-boundary.tsx";
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { pageTitle } from "@/utils/page-title.ts";
import { RoutePending } from "@/components/custom/route-pending.tsx";

export const Route = createFileRoute(
	"/_authenticated/settings/org/members/$userId",
)({
	loader: async ({ params, context: { queryClient } }) => {
		// Validated here rather than in `params.parse`, following
		// `projects/$projectId`: a parse throw happens during matching and escapes to
		// the global boundary, while a loader throw lands in `errorComponent` below.
		z.uuid().parse(params.userId);
		const member = await queryClient.ensureQueryData(
			memberDetailQueryOptions(params.userId),
		);
		return { member };
	},
	// A member from another org is a 404 by design (the endpoint makes cross-tenant
	// indistinguishable from missing), so this boundary is the normal way that arrives.
	errorComponent: createEntityErrorBoundary({
		title: m.member_not_found_title,
		description: m.member_not_found_description,
		backLabel: m.member_not_found_back,
		backTo: "/settings/org/members",
	}),
	head: ({ loaderData }) => ({
		meta: [
			{ title: pageTitle(loaderData?.member.email ?? m.member_detail_title()) },
		],
	}),
	component: MemberDetailLayout,
	pendingComponent: RoutePending,
});
